import {
  ImageScaleView,
  ImageScaleViewOpts,
  View,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { GoalId, getGoalMap } from '../game/defs/goal';
import { getGoalsPath } from '../game/util/assets';

type Match2GoalsPanelOpts = Omit<ImageScaleViewOpts, 'image'> & {
  countFontSize?: number;
  countOffsetX?: number;
  countOffsetY?: number;
};

export class Match2GoalItem extends View {
  public goalId!: GoalId;

  private goalIcon: ImageScaleView;
  private countText: LangBitmapFontTextView;
  private tickIcon: ImageScaleView;

  constructor(opts: Match2GoalsPanelOpts = {}) {
    const width = opts.width ?? 45;
    const height = opts.height ?? 45;
    const padding = 2.5;

    super({
      ...opts,
      width: width + padding,
      height: height + padding,
    });

    this.goalIcon = new ImageScaleView({
      parent: this,
      scaleMethod: 'contain',
      width,
      height,
    });

    this.countText = new LangBitmapFontTextView({
      parent: this,
      font: 'Title',
      color: '#FFFFFF',
      size: opts.countFontSize ?? 30,
      width: 90,
      height: 36,
      x: width - width * 0.04 + (opts.countOffsetX ?? 0),
      y: height - height * 0.33 + (opts.countOffsetY ?? 0),
      centerOnOrigin: true,
      localeText: () => '',
      verticalAlign: 'center',
      align: 'center',
    });

    this.tickIcon = new ImageScaleView({
      parent: this,
      width: 34.5,
      height: 33,
      x: width,
      y: height - 8,
      image: 'assets/ui/match2/common/icon_tick2.png',
      centerOnOrigin: true,
    });
  }

  public setGoal(id: GoalId, count: number, iconOverride?: string) {
    this.goalId = id;
    this.goalIcon.setImage(
      `${getGoalsPath()}${iconOverride ?? getGoalMap()[id]}`,
    );
    this.countText.localeText = () => `${count}`;
    this.countText.style.visible = count > 0;
    this.tickIcon.style.visible = count === 0;
  }
}
